import { InjectionToken } from '@angular/core';
import type { FirebaseStorage as FirebaseStorageInstance } from 'firebase/storage';

export const FirebaseStorage = new InjectionToken<FirebaseStorageInstance>(
	'marmon.firebase.storage',
);
